import { FlagBadge } from "./aak-flag-badge";

const LEGEND_SECTIONS = [
  {
    title: "Comptabilisation AAK",
    items: [
      { value: "I", label: "À l'immatriculation" },
      { value: "F", label: "À la saisie de la date de Facture client" },
      {
        value: "T",
        label: "À l'immatriculation + PV de livraison + Facture VN",
      },
    ],
  },
  {
    title: "Nature livraison",
    items: [
      { value: "L", label: "Livraison" },
      { value: "D", label: "Demo" },
      { value: "R", label: "Remplacement" },
      { value: "Z", label: "Destruction" },
    ],
  },
  {
    title: "Flag réseau",
    items: [
      { value: "O", label: "Oui" },
      { value: "N", label: "Non" },
      { value: "T", label: "Tous" },
    ],
  },
  {
    title: "Départ garantie",
    items: [{ value: "A", label: "À la livraison" }],
    note: "Vide = non applicable",
  },
] as const;

function AakLegend() {
  return (
    <div className="mt-4 rounded-lg bg-gray-50/60 px-6 py-4">
      <p className="mb-3 text-xs font-semibold tracking-wide text-gray-500 uppercase">
        Légende
      </p>
      <div className="grid grid-cols-4 gap-6">
        {LEGEND_SECTIONS.map((section) => (
          <div key={section.title}>
            <p className="mb-2 text-xs font-medium text-gray-500">
              {section.title}
            </p>
            <ul className="space-y-2">
              {section.items.map((item) => (
                <li key={item.value} className="flex items-center gap-2">
                  <FlagBadge value={item.value} />
                  <span className="text-xs text-gray-600">{item.label}</span>
                </li>
              ))}
            </ul>
            {"note" in section && (
              <p className="mt-2 text-xs text-gray-400 italic">
                {section.note}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export { AakLegend };
